<template>

<nav class="flex items-center justify-between bg-white px-4 py-3 sm:px-6" aria-label="Pagination" v-if="meta.total != 0">
  <div class="hidden sm:block">
    <p class="text-sm text-gray-700">
      Toont
      <span class="font-medium">{{ meta.from }}</span>
      tot
      <span class="font-medium">{{ meta.to }}</span>
      van
      <span class="font-medium">{{ meta.total }}</span>
      resultaten
    </p>
  </div>
  <div class="flex flex-1 justify-between sm:justify-end">
    <a :href="links.prev" class="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">Vorige</a>
    <a :href="links.next" class="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">Volgende</a>
  </div>
</nav>

<nav class="flex items-center justify-between bg-white px-4 py-3 sm:px-6" aria-label="Pagination" v-else>
  <div class="hidden sm:block">
    <p class="text-sm text-gray-700">Er zijn geen resultaten</p>
  </div>

</nav>

</template>

<script>

export default {
    props: {
        links: Object,
        meta: Object,
    }
}

</script>